export default __webpack_public_path__ + "static/media/system2.5b052376.png";